// WD-972 — Tipos de acción del catálogo Canal de Distribución
export const DISTRIBUTION_CHANNELS_FETCH_STARTED = 'DISTRIBUTION_CHANNELS_FETCH_STARTED';
export const DISTRIBUTION_CHANNELS_FETCH_COMPLETED = 'DISTRIBUTION_CHANNELS_FETCH_COMPLETED';
export const DISTRIBUTION_CHANNELS_FETCH_FAILED = 'DISTRIBUTION_CHANNELS_FETCH_FAILED';

export const DISTRIBUTION_CHANNEL_SAVE_STARTED = 'DISTRIBUTION_CHANNEL_SAVE_STARTED';
export const DISTRIBUTION_CHANNEL_SAVE_COMPLETED = 'DISTRIBUTION_CHANNEL_SAVE_COMPLETED';
export const DISTRIBUTION_CHANNEL_SAVE_FAILED = 'DISTRIBUTION_CHANNEL_SAVE_FAILED';

export const DISTRIBUTION_CHANNEL_DELETE_STARTED = 'DISTRIBUTION_CHANNEL_DELETE_STARTED';
export const DISTRIBUTION_CHANNEL_DELETE_COMPLETED = 'DISTRIBUTION_CHANNEL_DELETE_COMPLETED';
export const DISTRIBUTION_CHANNEL_DELETE_FAILED = 'DISTRIBUTION_CHANNEL_DELETE_FAILED';

export interface DistributionChannel {
  distributionChannelId: number;
  name: string;
  organizationId: number | null;
  organizationName?: string | null;
  divisionId: number | null;
  divisionName?: string | null;
  subdivisionId: number | null;
  subdivisionName?: string | null;
  status?: number;
  customersCount?: number;
  locationsCount?: number;
}
